import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

// i18n is wired from day one. Only English ships, but every visible string
// runs through t() so adding a locale is a translation job, not a refactor.
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
    },
    fallbackLng: 'en',
    supportedLngs: ['en'],
    interpolation: {
      // React already escapes.
      escapeValue: false,
    },
    returnNull: false,
  });

export default i18n;
